import type { INNOVATION } from '@/constants';
import {
  BACKEND_CAREER_COACHING,
  FRONTEND_CAREER_COACHING,
  INTERVIEW_ARTICLE_CHALLENGE,
  KDC_ALGORITHM,
  KDC_DOCKER,
  KDC_KUBERNETES,
  KDC_NEXT,
  KDC_TDD,
  PLUS_AI,
  PLUS_BACKEND,
  PLUS_FRONTEND,
  PLUS_LITE_BACKEND,
  PLUS_LITE_FRONTEND,
  REBOOT,
  SHORT_TERM_SKILL_UP,
} from '@/constants';
import type { CourseType } from '@/types';

export const COURSE_LANDING_URL: Record<
  Exclude<CourseType, typeof INNOVATION>,
  string
> = {
  [PLUS_BACKEND]: `/plus/be`,
  [PLUS_FRONTEND]: `/plus/fe`,
  [PLUS_AI]: '/plus/ai',

  [PLUS_LITE_BACKEND]: '/plus-lite/be',
  [PLUS_LITE_FRONTEND]: 'https://forms.gle/hTUJV8r2UvhFDwpN6',

  [REBOOT]: `/reboot`,
  ['99CLUB_CODING_TEST']: `/99club-codingtest`,

  [BACKEND_CAREER_COACHING]: 'https://hhplus-careercoaching.oopy.io/',
  [FRONTEND_CAREER_COACHING]: 'UNKNOWN',
  [SHORT_TERM_SKILL_UP]: 'https://hh-skillup.oopy.io/',

  [KDC_NEXT]: '/kdc/nextjs',
  [KDC_DOCKER]: '/kdc/docker',
  [KDC_KUBERNETES]: '/kdc/k8s',
  [KDC_TDD]: '/kdc/fe-tdd',
  [KDC_ALGORITHM]: '/kdc/algorithm',

  [INTERVIEW_ARTICLE_CHALLENGE]: '/99club-1day1study',
};
